import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LogService } from '../../services/log.service';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {
  message: string;
  confirmText: string;
  rejectText: string;

  constructor(public activeModal: NgbActiveModal, private log: LogService) {
    window.addEventListener('message', event => {
      if (event.data.type && event.data.type === 'confirm-dialog') {
        this.processMessage(event.data);
      }
    });
  }

  processMessage(data) {
    this.log.trace('ConfirmDialogComponent.processMessage', data);
    this.message = data.message;
    this.confirmText = data.confirmText;
    this.rejectText = data.rejectText;
  }

  ngOnInit() {}

  onAccept() {
    this.activeModal.close();
  }
  onReject() {
    this.activeModal.dismiss();
  }
}
